import { Icon, symbolName } from './Icon'

type WarningIconProps = Readonly<{
  size?: number
  color?: string
}>

export function WarningIcon({
  size = 32,
  color = '#DD1818',
}: WarningIconProps) {
  return (
    <Icon
      name={symbolName('exclamationmark.triangle.fill', 'warning')}
      size={size}
      color={color}
    />
  )
}
